import React from 'react';

interface IconProps {
  color?: string;
}

function Icon({ color = '#FF0000' }: IconProps): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12">
      <circle cx="6" cy="6" r="6" fill={color}></circle>
    </svg>
  );
}

export default Icon;
